module.exports = __webpack_public_path__ + "img/power-level-4.dd739b97.png";